'use strict';

import React, { Component } from 'react'

import ReactQuill from 'react-quill'

import { v4 as uniqid } from 'uuid'

export default class CreationForm extends Component
{
	state =
	{
		id: uniqid()
	};

	handleChange = (value) =>
	{
		const component = this, props = this.props;

		if (props.onChange instanceof Function)
		{
			props.onChange(value);
		}
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let modules =
		{
			toolbar:
			[
				[
					{ 'header': [1, 2, false] }
				],

				[
					{ align: ['justify', 'center', 'right'] }
				],

				[
					'bold', 'italic', 'underline','strike', 'blockquote'
				],

				[
					{'list': 'ordered'},
					{'list': 'bullet'},
					{'indent': '-1'},
					{'indent': '+1'}
				],

				['link'],

				['clean'],

				['color']
			]
		};

		let formats =
		[
			'header',
			'align',
			'bold', 'italic', 'underline', 'strike', 'blockquote',
			'list', 'bullet', 'indent',
			'link',
			'left', 'center', 'right', 'justify'
		];

		if (props.images)
		{
			formats.push('image');

			modules.toolbar[3].push('image');
		}

		if (props.color)
		{
			formats.push('color');
		}

		modules =
		{
			toolbar:
			{
				container: '#toolbar-' + state.id
			}
		};

		var output =
		(
			<div className="text-editor">

				<div id={ 'toolbar-' + state.id } className="ql-toolbar ql-snow">

					<span className="ql-formats">

						<select className="ql-header" defaultValue={ '' }
							onChange={ e => e.persist() }>
							<option value="1" />
							<option value="2" />
							<option selected />
						</select>

					</span>

					<span className="ql-formats">

						<select className="ql-align" defaultValue={ '' }
							onChange={ e => e.persist() }>
							<option />
							<option value="1" />
							<option value="2" />
						</select>

					</span>

					<span className="ql-formats">

						<button className="ql-bold" />
						<button className="ql-italic" />
						<button className="ql-underline" />
						<button className="ql-strike" />
						<button className="ql-blockquote" />

					</span>

					<span className="ql-formats">
						<button className="ql-list" value="ordered" />
						<button className="ql-list" value="bullet" />
						<button className="ql-indent" value="-1" />
						<button className="ql-indent" value="+1" />
						{
							props.images
							? <button className="ql-image" />
							: undefined
						}
					</span>

					<span className="ql-formats">
						<button className="ql-link" />
					</span>

					<span className="ql-formats">
						<button className="ql-clean" />
					</span>

					{
						props.color ?
						(
							<span className="ql-formats">

								<select className="ql-color">
									<option selected />
									<option value="#f6a804" />
									<option value="#911f18" />
									<option value="#d33535" />
									<option value="#2196f3" />
									<option value="#00bcd4" />
									<option value="#009688" />
									<option value="#4caf50" />
									<option value="#ffeb3b" />
									<option value="#9e9e9e" />
									<option value="#607d8b" />
								</select>

							</span>
						)
						: undefined
					}

				</div>

				<ReactQuill value={ props.value } formats={ formats }
					onChange={ component.handleChange } modules={ modules }
					id={ state.id }
				/>

			</div>
		);

		return output;
	}
}
